module.exports = __webpack_public_path__ + "img/Evanghelia_greco-romana_Bucuresti_1693_foaie_de_titlu.e3f8519c.png";